import React, { useEffect } from "react";
import logo from "src/img/logo.png";
import { Formik } from "formik";
import * as yup from "yup";
import { CustomInput } from "src/component";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";


import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { renderToastMsg } from "src/utils/functions";
import { signin } from "src/services/api";

const Login = () => {
    const { setUser, setToken, user, token } = useProtectedRoutesContext();
    const navigate = useNavigate();


    useEffect(() => {
        if (user && token) {
            navigate('/admin/appliances');
        }
    }, [user, token, navigate]);

    const signInSchema = yup.object().shape({
        email: yup
            .string()
            .email("Please provide a valid email")
            .required("Please provide a valid email"),
        password: yup.string().required("Please provide password"),
    });

    const initialValues = {
        email: "",
        password: "",
    };

    useEffect(() => {

    }, [])


    const { mutate, isLoading } = useMutation(signin, {
        onSuccess: (res) => {
            if (res?.status === "success") {
                setUser(res?.data?.user)
                setToken(res?.data?.access_token);
                renderToastMsg(res?.msg, "success").then(() => {
                    navigate("/admin/appliances");
                });
            } else {
                renderToastMsg(res?.msg);
            }
        },
    });

    return (
        <>
            <div className="flex items-center justify-center h-full">
                <div className="w-[600px] mx-auto my-[50px] px-[50px] min-h-[80%] relative">

                    <div className="flex justify-center">
                        <img src={logo} className="w-[25rem] " alt="revocube energies " />
                    </div>

                    <div className="my-[50px]">
                        <p className=" text-dark text-[2.4rem]  text-center font-bold leading-none mb-8">
                            Welcome Back
                        </p>
                        <p className=" text-lightGray text-center text-[1.6rem] font-normal ">
                            Fill your email address and password to continue
                        </p>

                        {/* form */}
                        <div className="my-[30px]">
                            <Formik
                                initialValues={initialValues}
                                validationSchema={signInSchema}
                                onSubmit={(values) => mutate(values)}
                            >
                                {({ values, handleChange, handleBlur, handleSubmit }) => (
                                    <form onSubmit={handleSubmit}>
                                        <CustomInput
                                            title="Email Address"
                                            name="email"
                                            onChange={handleChange}
                                            value={values.email}
                                            onBlur={handleBlur}
                                        />
                                        <CustomInput
                                            title="Password"
                                            name="password"
                                            passwordToggle
                                            onChange={handleChange}
                                            value={values.password}
                                            onBlur={handleBlur}
                                        />
                                        {/*  <div className="flex items-center justify-between mb-[20px] ">

                                                        <Link
                                                            to="/forget-password"
                                                            className=" text-primary text-[1.5rem] font-medium leading-none m"
                                                        >
                                                            Forgot Password?
                                                        </Link>
                                                    </div> */}

                                        <button
                                            disabled={isLoading}
                                            type="submit"
                                            className="w-full btn-loader p-[15px] bg-lightPrimary rounded-[5px] justify-center items-center gap-2.5 inline-flex text-center text-defaultPrimary text-[1.4rem] font-medium leading-none my-[10px]"
                                        >
                                            Sign in
                                        </button>

                                    </form>
                                )}
                            </Formik>
                        </div>

                        <div className="my-auto absolute text-center bottom-0 left-0 right-0">
                            <p className="text-lightGray  text-[1.4rem] font-medium leading-none">
                                Revocube Energies. All rights reserved.
                                <span className="ml-2">{new Date().getFullYear()}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
